/* Product page, mobile: the "Try it in your room" button becomes a small pill on the first photo,
   so the name and price fit in the first screen. The room link (added by the footer script once the
   high-quality model is ready) or Shopify's AR button keeps its own behaviour. */
(function () {
  if (window.matchMedia('(min-width: 700px)').matches) return;
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z M12 12l8-4.5 M12 12v9 M12 12L4 7.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
  function visible(el) { return el && el.getBoundingClientRect().width > 0; }

  function pill(gallery, btn) {
    var first = gallery.querySelector('.product-gallery__media');
    if (!first) return false;
    if (getComputedStyle(first).position === 'static') first.style.position = 'relative';
    btn.classList.remove('w-full', 'button');
    btn.classList.add('mj-ar-pill');
    btn.innerHTML = ICON + '<span>In your room</span>';
    first.appendChild(btn);
    return true;
  }

  function start() {
    var gallery = document.querySelector('.product-gallery');
    if (!gallery) return;
    var placeRoom = function () {
      var link = gallery.querySelector('.mj-product-room-link:not(.mj-ar-pill)');
      return visible(link) ? pill(gallery, link) : false;
    };
    if (placeRoom()) return;
    var mo = new MutationObserver(function () { if (placeRoom()) mo.disconnect(); });
    mo.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'data-quality-ready'] });
    setTimeout(function () {
      mo.disconnect();
      if (gallery.querySelector('.mj-ar-pill')) return;
      var xr = Array.prototype.find.call(gallery.querySelectorAll('[data-shopify-xr]'), visible);
      if (xr) pill(gallery, xr);
    }, 5000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
